import { useMutation, useQueryClient } from "@tanstack/react-query";

import {
  invalidateSkillCollectionDetailQueries,
  invalidateSkillCollectionListQueries,
} from "./cache-utils";

import { ENDPOINTS } from "@/api/application-api";
import { useAuth } from "@/context/auth-context";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { jsonAuthHeaders } from "@/utils/headers";
import { displayErrorToast } from "@/utils/toast";

interface DeleteSkillCollectionParams {
  workspaceId: number;
  collectionId: number | string;
}

interface DeleteSkillCollectionResponse {
  success: boolean;
  message: string;
}

export const useDeleteSkillCollection = () => {
  const auth = useAuth();
  const userToken = auth?.userToken ?? "";
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      workspaceId,
      collectionId,
    }: DeleteSkillCollectionParams): Promise<DeleteSkillCollectionResponse> => {
      const res = await fetch(ENDPOINTS.skill_collections.get(workspaceId, String(collectionId)), {
        method: "DELETE",
        headers: jsonAuthHeaders(userToken),
      });
      return handleResponse(res);
    },
    onSuccess: (_, variables) => {
      invalidateSkillCollectionListQueries(queryClient, variables.workspaceId);
      invalidateSkillCollectionDetailQueries(queryClient, variables);
    },
    onError: (error: Error) => {
      displayErrorToast(error.message);
    },
  });
};
